import React from "react";
import { Input } from "antd";
import { InputWrap, WrapperURL } from "./style";
import Label from "../style";

const URLInput = ({
  value,
  onChange,
  onBlur,
  name,
  status,
  label,
  ...rest
}) => (
  <WrapperURL>
    <div direction="vertical" {...rest}>
      <div>
        <Label title={label} />
      </div>
      <InputWrap>
        <Input
          addonBefore="http://"
          className={`inputURl ${status === "error" ? "error" : ""}`}
          type="text"
          value={value}
          onChange={onChange}
          onBlur={onBlur}
          name={name}
          status={status ?? ""}
        />
      </InputWrap>
    </div>
  </WrapperURL>
);

export default URLInput;
